import { SelectOptionType } from "../types";

/**
 * Alberta (AB) referral reasons.
 */
const AB_REFERRAL_REASONS: SelectOptionType[] = [
  {
    value: "Associate Absent due to injury",
    label: "Associate Absent due to injury",
  },
  {
    value: "Associate has requested OOMD past DOI",
    label: "Associate has requested OOMD past DOI",
  },
  {
    value: "Associate has requested outside treatment and/or evaluation",
    label: "Associate has requested outside treatment and/or evaluation",
  },
  {
    value:
      "Associate is being referred by AMCARE as they require treatment greater than first aid.",
    label:
      "Associate is being referred by AMCARE as they require treatment greater than first aid.",
  },
  {
    value: "Associate sought treatment after reporting their injury.",
    label: "Associate sought treatment after reporting their injury.",
  },
  {
    value:
      "Associate sought treatment before reporting their injury (AMCARE Bypass).",
    label:
      "Associate sought treatment before reporting their injury (AMCARE Bypass).",
  },
  { value: "Other", label: "Other" },
];

/**
 * British Columbia (BC) referral reasons.
 */
const BC_REFERRAL_REASONS: SelectOptionType[] = [
  {
    value: "Associate Absent due to injury",
    label: "Associate Absent due to injury",
  },
  {
    value: "Associate has requested OOMD past DOI",
    label: "Associate has requested OOMD past DOI",
  },
  {
    value: "Associate has requested outside treatment and/or evaluation",
    label: "Associate has requested outside treatment and/or evaluation",
  },
  {
    value:
      "Associate is being referred by AMCARE as they require treatment greater than first aid.",
    label:
      "Associate is being referred by AMCARE as they require treatment greater than first aid.",
  },
  {
    value: "Associate sought treatment after reporting their injury.",
    label: "Associate sought treatment after reporting their injury.",
  },
  {
    value:
      "Associate sought treatment before reporting their injury (AMCARE Bypass).",
    label:
      "Associate sought treatment before reporting their injury (AMCARE Bypass).",
  },
  { value: "Other", label: "Other" },
];

/**
 * Manitoba (MB) referral reasons.
 */
const MB_REFERRAL_REASONS: SelectOptionType[] = [
  { value: "Other", label: "Other" },
  {
    value: "Worker has sought medical attention",
    label: "Worker has sought medical attention",
  },
  {
    value: "Worker is absent due to their injury",
    label: "Worker is absent due to their injury",
  },
  {
    value:
      "Worker is being referred by Amazon as they require treatment greater than first aid",
    label:
      "Worker is being referred by Amazon as they require treatment greater than first aid",
  },
];

/**
 * Shared referral reasons for NB, NL, NT, NU, ON, PE, SK, YT.
 */
const SHARED_REFERRAL_REASONS: SelectOptionType[] = [
  {
    value: "Associate Absent due to injury",
    label: "Associate Absent due to injury",
  },
  {
    value:
      "Associate has reached 7 calendar days of modified duties and requires referral per WSIB policy",
    label:
      "Associate has reached 7 calendar days of modified duties and requires referral per WSIB policy",
  },
  {
    value: "Associate has requested outside treatment and/or evaluation",
    label: "Associate has requested outside treatment and/or evaluation",
  },
  {
    value:
      "Associate is being referred by AMCARE as they require treatment greater than first aid.",
    label:
      "Associate is being referred by AMCARE as they require treatment greater than first aid.",
  },
  {
    value: "Associate sought treatment after reporting their injury.",
    label: "Associate sought treatment after reporting their injury.",
  },
  {
    value:
      "Associate sought treatment before reporting their injury (AMCARE Bypass).",
    label:
      "Associate sought treatment before reporting their injury (AMCARE Bypass).",
  },
  { value: "Other", label: "Other" },
];

/**
 * Nova Scotia (NS) referral reasons.
 */
const NS_REFERRAL_REASONS: SelectOptionType[] = [
  { value: "Other", label: "Other" },
  {
    value: "Worker has sought medical attention",
    label: "Worker has sought medical attention",
  },
  {
    value: "Worker is absent due to their injury",
    label: "Worker is absent due to their injury",
  },
  {
    value:
      "Worker is being referred by Amazon as they require treatment greater than first aid",
    label:
      "Worker is being referred by Amazon as they require treatment greater than first aid",
  },
];

/**
 * Quebec (QC) referral reasons.
 */
const QC_REFERRAL_REASONS: SelectOptionType[] = [
  { value: "Other", label: "Other" },
  {
    value:
      "Worker has provided a certification regarding CNESST Safe Maternity Program (PMSD)",
    label:
      "Worker has provided a certification regarding CNESST Safe Maternity Program (PMSD)",
  },
  {
    value: "Worker has provided CNESST medical documents",
    label: "Worker has provided CNESST medical documents",
  },
];

/**
 * Province-to-referral-reasons mapping.
 * Provinces NB, NL, NT, NU, ON, PE, SK, YT share the same list.
 * AB, BC, MB, NS, QC each have distinct lists.
 */
export const SEDGWICK_CANADA_REFERRAL_REASONS_BY_PROVINCE: Record<
  string,
  SelectOptionType[]
> = {
  AB: AB_REFERRAL_REASONS,
  BC: BC_REFERRAL_REASONS,
  MB: MB_REFERRAL_REASONS,
  NB: SHARED_REFERRAL_REASONS,
  NL: SHARED_REFERRAL_REASONS,
  NT: SHARED_REFERRAL_REASONS,
  NU: SHARED_REFERRAL_REASONS,
  ON: SHARED_REFERRAL_REASONS,
  PE: SHARED_REFERRAL_REASONS,
  SK: SHARED_REFERRAL_REASONS,
  YT: SHARED_REFERRAL_REASONS,
  NS: NS_REFERRAL_REASONS,
  QC: QC_REFERRAL_REASONS,
};

/**
 * Returns the referral reasons options for a given Canadian province code.
 * Returns an empty array for unknown province codes.
 */
export const getReferralReasonsByProvince = (
  province: string
): SelectOptionType[] => {
  return SEDGWICK_CANADA_REFERRAL_REASONS_BY_PROVINCE[province] || [];
};
